/* ═══════════════════════════════════════════════════════
   STUNTING.ID — Data layer
   Global: window.SITE_DATA
   ═══════════════════════════════════════════════════════ */
(function (global) {
  'use strict';

  /* ─────────────────────────────────────────────────────
     1. STANDAR PERTUMBUHAN ANAK WHO 2006
        Tinggi/Panjang Badan menurut Umur (TB/U — HFA/LFA)

        Tabel di bawah adalah TITIK JANGKAR dari tabel WHO.
        Nilai antar-jangkar dihitung dengan interpolasi linier.
        Untuk indikator TB/U, WHO memakai L = 1 sehingga
        distribusinya normal dan skor-Z dihitung dengan:

            Z = (tinggi_anak − median) / SD

        Catatan: pada umur 24 bulan standar beralih dari
        panjang badan (berbaring) ke tinggi badan (berdiri),
        sehingga median turun ± 0,7 cm. Ini normal & disengaja.
     ───────────────────────────────────────────────────── */

  // [umurBulan, median_cm, SD_cm]
  var WHO_HFA = {
    M: [
      [0, 49.9, 1.89], [1, 54.7, 1.95], [2, 58.4, 2.00], [3, 61.4, 2.05],
      [4, 63.9, 2.09], [5, 65.9, 2.12], [6, 67.6, 2.16], [7, 69.2, 2.19],
      [8, 70.6, 2.22], [9, 72.0, 2.26], [10, 73.3, 2.29], [11, 74.5, 2.32],
      [12, 75.7, 2.35], [13, 76.9, 2.41], [14, 78.0, 2.47], [15, 79.1, 2.52],
      [16, 80.2, 2.58], [17, 81.2, 2.64], [18, 82.3, 2.70], [19, 83.2, 2.76],
      [20, 84.2, 2.82], [21, 85.1, 2.88], [22, 86.0, 2.93], [23, 86.9, 2.99],
      [24, 87.1, 3.05], [27, 89.6, 3.22], [30, 91.9, 3.39], [33, 94.1, 3.55],
      [36, 96.1, 3.70], [39, 98.0, 3.83], [42, 99.9, 3.95], [45, 101.6, 4.08],
      [48, 103.3, 4.20], [51, 105.0, 4.32], [54, 106.7, 4.43], [57, 108.3, 4.54],
      [60, 110.0, 4.65]
    ],
    F: [
      [0, 49.1, 1.86], [1, 53.7, 1.91], [2, 57.1, 1.96], [3, 59.8, 2.02],
      [4, 62.1, 2.10], [5, 64.0, 2.18], [6, 65.7, 2.25], [7, 67.3, 2.30],
      [8, 68.7, 2.35], [9, 70.1, 2.40], [10, 71.5, 2.45], [11, 72.8, 2.50],
      [12, 74.0, 2.55], [13, 75.2, 2.58], [14, 76.4, 2.60], [15, 77.5, 2.63],
      [16, 78.6, 2.66], [17, 79.7, 2.69], [18, 80.7, 2.72], [19, 81.7, 2.74],
      [20, 82.7, 2.76], [21, 83.7, 2.79], [22, 84.6, 2.81], [23, 85.5, 2.83],
      [24, 85.7, 2.85], [27, 88.4, 3.13], [30, 90.7, 3.38], [33, 93.0, 3.62],
      [36, 95.1, 3.85], [39, 97.1, 3.97], [42, 99.0, 4.08], [45, 100.9, 4.19],
      [48, 102.7, 4.30], [51, 104.5, 4.41], [54, 106.2, 4.52], [57, 107.8, 4.63],
      [60, 109.4, 4.75]
    ]
  };

  /** Interpolasi linier tabel WHO → { median, sd } untuk umur (bulan) mana pun 0–60. */
  function whoRef(sex, months) {
    var t = WHO_HFA[sex] || WHO_HFA.M;
    var m = Math.min(Math.max(months, t[0][0]), t[t.length - 1][0]);
    for (var i = 0; i < t.length - 1; i++) {
      var a = t[i], b = t[i + 1];
      if (m >= a[0] && m <= b[0]) {
        var f = b[0] === a[0] ? 0 : (m - a[0]) / (b[0] - a[0]);
        return {
          median: a[1] + (b[1] - a[1]) * f,
          sd: a[2] + (b[2] - a[2]) * f
        };
      }
    }
    var last = t[t.length - 1];
    return { median: last[1], sd: last[2] };
  }

  /** Tinggi badan pada skor-Z tertentu. */
  function heightAtZ(sex, months, z) {
    var r = whoRef(sex, months);
    return r.median + z * r.sd;
  }

  /** Skor-Z TB/U. */
  function zScore(sex, months, heightCm) {
    var r = whoRef(sex, months);
    return (heightCm - r.median) / r.sd;
  }

  /** Persentil ≈ dari skor-Z (aproksimasi CDF normal, Abramowitz–Stegun 26.2.17). */
  function zToPercentile(z) {
    var s = z < 0 ? -1 : 1, x = Math.abs(z) / Math.SQRT2;
    var t = 1 / (1 + 0.3275911 * x);
    var y = 1 - (((((1.061405429 * t - 1.453152027) * t) + 1.421413741) * t - 0.284496736) * t + 0.254829592) * t * Math.exp(-x * x);
    return 0.5 * (1 + s * y) * 100;
  }

  /** Klasifikasi status TB/U sesuai Permenkes 2/2020 & standar WHO. */
  function classify(z) {
    if (z < -3) return {
      key: 'severe', tone: 'bad', icon: '⚠',
      label: 'Sangat Pendek (Severely Stunted)',
      desc: 'Tinggi badan berada di bawah −3 SD. Ini termasuk kategori berat dan memerlukan pemeriksaan tenaga kesehatan secepatnya.'
    };
    if (z < -2) return {
      key: 'stunted', tone: 'warn', icon: '!',
      label: 'Pendek (Stunted)',
      desc: 'Tinggi badan berada antara −3 SD dan −2 SD. Anak terindikasi stunting dan perlu dikonfirmasi serta ditangani oleh tenaga kesehatan.'
    };
    if (z < -1) return {
      key: 'risk', tone: 'info', icon: '~',
      label: 'Normal — Perlu Dipantau',
      desc: 'Masih dalam rentang normal, namun mendekati batas bawah. Jaga asupan gizi dan pantau pertumbuhan setiap bulan di Posyandu.'
    };
    if (z <= 3) return {
      key: 'normal', tone: 'good', icon: '✓',
      label: 'Normal',
      desc: 'Tinggi badan sesuai umur menurut Standar Pertumbuhan Anak WHO. Pertahankan pola makan bergizi seimbang dan pemantauan rutin.'
    };
    return {
      key: 'tall', tone: 'info', icon: '↑',
      label: 'Tinggi',
      desc: 'Tinggi badan di atas +3 SD. Umumnya bukan masalah, tetapi konsultasikan bila disertai keluhan pertumbuhan lain.'
    };
  }

  /** Saran tindak lanjut sesuai kategori & umur. */
  function adviceFor(key, months) {
    var young = months < 24;
    var base = {
      severe: [
        ['Segera ke fasilitas kesehatan', 'Bawa anak ke Puskesmas atau dokter anak dalam waktu dekat untuk pemeriksaan menyeluruh dan penapisan penyakit penyerta.'],
        ['Cari penyebab medis', 'Infeksi kronis, TBC, kelainan penyerapan, atau penyakit bawaan perlu disingkirkan lebih dulu.'],
        ['Terapi gizi terarah', 'Tenaga gizi akan menghitung kebutuhan energi & protein anak, bukan sekadar menambah porsi makan.'],
        ['Pantau setiap bulan', 'Pengukuran ulang secara rutin menentukan apakah intervensi sudah berhasil.']
      ],
      stunted: [
        ['Konfirmasi pengukuran', 'Ulangi pengukuran di Posyandu dengan alat terstandar — kesalahan ukur 1–2 cm dapat mengubah kesimpulan.'],
        ['Tambah protein hewani harian', 'Telur, ikan, hati ayam, atau daging setiap hari terbukti mempercepat pertumbuhan panjang badan.'],
        ['Periksa kesehatan lingkungan', 'Diare berulang membuat gizi tidak terserap. Pastikan air minum matang dan sanitasi layak.'],
        ['Konsultasi tenaga gizi', 'Minta rencana pemberian makan yang disesuaikan dengan umur dan kondisi anak.']
      ],
      risk: [
        ['Tingkatkan kepadatan gizi', 'Utamakan makanan padat gizi dibanding porsi besar yang rendah nutrisi.'],
        ['Jangan lewatkan penimbangan', 'Kunjungi Posyandu tiap bulan agar tren pertumbuhan terlihat lebih dini.'],
        ['Cukupi tidur & stimulasi', 'Hormon pertumbuhan bekerja paling aktif saat anak tidur nyenyak.']
      ],
      normal: [
        ['Pertahankan pola makan', 'Isi Piringku setiap kali makan: makanan pokok, lauk, sayur, dan buah.'],
        ['Lanjutkan imunisasi lengkap', 'Mencegah infeksi berarti melindungi pertumbuhan.'],
        ['Tetap ukur tiap bulan', 'Status normal hari ini tidak menjamin bulan depan — pemantauan tetap penting.']
      ],
      tall: [
        ['Umumnya tidak perlu khawatir', 'Tinggi di atas rata-rata jarang menjadi masalah pada balita.'],
        ['Perhatikan proporsi berat badan', 'Pastikan berat badan juga sesuai agar status gizi tetap seimbang.']
      ]
    }[key] || [];

    if (young) {
      base = base.concat([[
        'Masih dalam masa emas',
        'Anak Anda berumur di bawah 2 tahun — ini periode ketika perbaikan gizi masih memberi dampak paling besar terhadap tinggi badan.'
      ]]);
    } else {
      base = base.concat([[
        'Fokus ke kualitas hidup',
        'Di atas 2 tahun, pertambahan tinggi lebih sulit dikejar. Tetap optimalkan gizi, stimulasi, dan kesehatan agar potensi kognitif berkembang maksimal.'
      ]]);
    }
    return base;
  }

  /* ─────────────────────────────────────────────────────
     2. PREVALENSI PROVINSI
     ───────────────────────────────────────────────────── */
  var PROVINCES = [
    { n: 'Aceh', v: 29.4 }, { n: 'Sumatera Utara', v: 18.9 }, { n: 'Sumatera Barat', v: 24.0 },
    { n: 'Riau', v: 13.6 }, { n: 'Jambi', v: 13.5 }, { n: 'Sumatera Selatan', v: 19.9 },
    { n: 'Bengkulu', v: 20.2 }, { n: 'Lampung', v: 14.9 }, { n: 'Bangka Belitung', v: 21.5 },
    { n: 'Kepulauan Riau', v: 16.8 }, { n: 'DKI Jakarta', v: 17.6 }, { n: 'Jawa Barat', v: 21.7 },
    { n: 'Jawa Tengah', v: 20.7 }, { n: 'DI Yogyakarta', v: 18.0 }, { n: 'Jawa Timur', v: 17.7 },
    { n: 'Banten', v: 24.0 }, { n: 'Bali', v: 7.2 }, { n: 'Nusa Tenggara Barat', v: 24.6 },
    { n: 'Nusa Tenggara Timur', v: 37.9 }, { n: 'Kalimantan Barat', v: 24.0 },
    { n: 'Kalimantan Tengah', v: 23.5 }, { n: 'Kalimantan Selatan', v: 24.7 },
    { n: 'Kalimantan Timur', v: 22.9 }, { n: 'Kalimantan Utara', v: 17.6 },
    { n: 'Sulawesi Utara', v: 19.9 }, { n: 'Sulawesi Tengah', v: 27.2 },
    { n: 'Sulawesi Selatan', v: 27.4 }, { n: 'Sulawesi Tenggara', v: 30.0 },
    { n: 'Gorontalo', v: 26.9 }, { n: 'Sulawesi Barat', v: 30.3 },
    { n: 'Maluku', v: 28.4 }, { n: 'Maluku Utara', v: 23.7 },
    { n: 'Papua Barat', v: 20.5 }, { n: 'Papua Barat Daya', v: 21.0 },
    { n: 'Papua', v: 28.6 }, { n: 'Papua Selatan', v: 25.0 },
    { n: 'Papua Tengah', v: 39.4 }, { n: 'Papua Pegunungan', v: 37.3 }
  ];

  var NATIONAL = 21.5;   // SKI 2023
  var TARGET = 14.0;     // Target RPJMN 2024

  function provStatus(v) {
    if (v >= 30) return 'Sangat tinggi (WHO: ≥30%)';
    if (v >= 20) return 'Tinggi (WHO: 20–29%)';
    if (v >= 10) return 'Sedang (WHO: 10–19%)';
    return 'Rendah (WHO: <10%)';
  }

  /* ─────────────────────────────────────────────────────
     3. ZAT GIZI + struktur molekul (disederhanakan)
     ───────────────────────────────────────────────────── */
  var EL = {
    H: { c: 0xdfe7f2, r: 0.30 }, C: { c: 0x3a4a63, r: 0.52 },
    N: { c: 0x4a8cff, r: 0.50 }, O: { c: 0xff5470, r: 0.48 },
    P: { c: 0xffb648, r: 0.58 }, S: { c: 0xffd83d, r: 0.58 },
    Fe: { c: 0xff8a3d, r: 0.78 }, Zn: { c: 0x8b6cff, r: 0.76 },
    Ca: { c: 0x2ee6c5, r: 0.80 }, I: { c: 0xa855f7, r: 0.74 }
  };

  // helper: bangun kompleks logam (pusat + ligan simetris)
  function complexMol(metal, ligand, positions, withH) {
    var atoms = [{ el: metal, p: [0, 0, 0] }], bonds = [];
    positions.forEach(function (p) {
      var i = atoms.length;
      atoms.push({ el: ligand, p: p });
      bonds.push([0, i]);
      if (withH) {
        var len = Math.hypot(p[0], p[1], p[2]) || 1;
        var u = [p[0] / len, p[1] / len, p[2] / len];
        // dua H menempel pada ligan, digeser tegak lurus
        var perp = Math.abs(u[1]) < 0.9 ? [0, 1, 0] : [1, 0, 0];
        var cx = [u[1] * perp[2] - u[2] * perp[1], u[2] * perp[0] - u[0] * perp[2], u[0] * perp[1] - u[1] * perp[0]];
        var cl = Math.hypot(cx[0], cx[1], cx[2]) || 1;
        cx = [cx[0] / cl, cx[1] / cl, cx[2] / cl];
        [-1, 1].forEach(function (s) {
          var h = [p[0] + u[0] * 0.6 + cx[0] * 0.62 * s, p[1] + u[1] * 0.6 + cx[1] * 0.62 * s, p[2] + u[2] * 0.6 + cx[2] * 0.62 * s];
          atoms.push({ el: 'H', p: h });
          bonds.push([i, atoms.length - 1]);
        });
      }
    });
    return { atoms: atoms, bonds: bonds };
  }

  var OCTA = [[2.05, 0, 0], [-2.05, 0, 0], [0, 2.05, 0], [0, -2.05, 0], [0, 0, 2.05], [0, 0, -2.05]];
  var TETRA = [[1.25, 1.25, 1.25], [-1.25, -1.25, 1.25], [-1.25, 1.25, -1.25], [1.25, -1.25, -1.25]];

  // Glisin — asam amino paling sederhana (mewakili protein)
  var GLYCINE = {
    atoms: [
      { el: 'N', p: [-2.30, 0.35, 0] }, { el: 'C', p: [-0.90, -0.35, 0.15] },
      { el: 'C', p: [0.55, 0.42, -0.05] }, { el: 'O', p: [1.72, -0.28, 0.30] },
      { el: 'O', p: [0.68, 1.62, -0.48] },
      { el: 'H', p: [-2.35, 1.28, -0.40] }, { el: 'H', p: [-3.05, -0.18, -0.42] },
      { el: 'H', p: [-0.92, -1.28, -0.44] }, { el: 'H', p: [-0.88, -0.62, 1.22] },
      { el: 'H', p: [2.58, 0.18, 0.18] }
    ],
    bonds: [[0, 1], [1, 2], [2, 3], [2, 4], [0, 5], [0, 6], [1, 7], [1, 8], [3, 9]]
  };

  // Retinol (vitamin A) — kerangka disederhanakan: cincin + rantai poliena + OH
  var RETINOL = (function () {
    var atoms = [], bonds = [], i;
    var RING_X = -3.3, RING_R = 1.35;

    // cincin sikloheksena (atom 0–5); atom 0 berada di sisi kanan cincin
    for (i = 0; i < 6; i++) {
      var a = (i / 6) * Math.PI * 2;
      atoms.push({ el: 'C', p: [RING_X + Math.cos(a) * RING_R, Math.sin(a) * RING_R, 0] });
      bonds.push([i, (i + 1) % 6]);
    }

    // rantai poliena — dimulai satu ikatan penuh dari atom cincin agar
    // tidak ada ikatan sepanjang nol (arah cylinder menjadi tak terdefinisi)
    var STEP = 1.06;
    var chainStart = atoms[0].p[0] + STEP;   // = -2.24 + 1.06
    var prev = 0, x = chainStart;
    var chainIdx = [];
    for (var k = 0; k < 6; k++) {
      atoms.push({ el: 'C', p: [x, (k % 2 ? 0.52 : -0.32), 0] });
      bonds.push([prev, atoms.length - 1]);
      prev = atoms.length - 1;
      chainIdx.push(prev);
      x += STEP;
    }

    // gugus hidroksil di ujung rantai
    var tip = atoms[prev].p;
    atoms.push({ el: 'O', p: [tip[0] + 0.95, tip[1] + 0.55, 0] });
    var oIdx = atoms.length - 1;
    bonds.push([prev, oIdx]);
    atoms.push({ el: 'H', p: [tip[0] + 1.75, tip[1] + 1.05, 0] });
    bonds.push([oIdx, atoms.length - 1]);

    // dua gugus metil khas retinol
    atoms.push({ el: 'C', p: [RING_X, RING_R + 1.15, 0] });
    bonds.push([1, atoms.length - 1]);
    var m2 = atoms[chainIdx[1]].p;
    atoms.push({ el: 'C', p: [m2[0], m2[1] + 1.20, 0] });
    bonds.push([chainIdx[1], atoms.length - 1]);

    return { atoms: atoms, bonds: bonds };
  })();

  // Fragmen hidroksiapatit — kalsium fosfat
  var CAP = (function () {
    var atoms = [{ el: 'P', p: [0, 0, 0] }], bonds = [];
    TETRA.forEach(function (p, i) {
      atoms.push({ el: 'O', p: [p[0] * 1.25, p[1] * 1.25, p[2] * 1.25] });
      bonds.push([0, i + 1]);
    });
    [[3.4, 1.5, 0], [-3.4, -1.5, 0], [0, 3.2, 2.4]].forEach(function (p) {
      atoms.push({ el: 'Ca', p: p });
    });
    return { atoms: atoms, bonds: bonds };
  })();

  // Fragmen tiroksin — cincin benzena beryodium (mewakili yodium)
  var THYRO = (function () {
    var atoms = [], bonds = [];
    for (var i = 0; i < 6; i++) {
      var a = (i / 6) * Math.PI * 2;
      atoms.push({ el: 'C', p: [Math.cos(a) * 1.4, Math.sin(a) * 1.4, 0] });
      bonds.push([i, (i + 1) % 6]);
    }
    atoms.push({ el: 'I', p: [2.6 * Math.cos(0), 2.6 * Math.sin(0), 0.6] }); bonds.push([0, 6]);
    atoms.push({ el: 'I', p: [2.6 * Math.cos(Math.PI * 2 / 3), 2.6 * Math.sin(Math.PI * 2 / 3), -0.6] }); bonds.push([2, 7]);
    atoms.push({ el: 'O', p: [2.6 * Math.cos(Math.PI), 2.6 * Math.sin(Math.PI), 0] }); bonds.push([3, 8]);
    atoms.push({ el: 'H', p: [3.5 * Math.cos(Math.PI), 0.8, 0] }); bonds.push([8, 9]);
    atoms.push({ el: 'N', p: [2.2 * Math.cos(Math.PI * 4 / 3), 2.2 * Math.sin(Math.PI * 4 / 3), 0.5] }); bonds.push([4, 10]);
    return { atoms: atoms, bonds: bonds };
  })();

  var NUTRIENTS = [
    {
      id: 'protein', name: 'Protein Hewani', formula: 'C<sub>2</sub>H<sub>5</sub>NO<sub>2</sub>',
      sub: 'ditampilkan sebagai glisin — asam amino penyusun protein',
      color: '#4a8cff', mol: GLYCINE,
      role: 'Bahan baku utama pembentukan jaringan, tulang rawan lempeng pertumbuhan, enzim, dan hormon pertumbuhan (IGF-1). Kekurangan protein hewani adalah salah satu prediktor stunting terkuat pada anak Indonesia.',
      sources: ['Telur', 'Ikan kembung', 'Hati ayam', 'Daging sapi', 'Ayam', 'Susu', 'Ikan teri'],
      need: '≈ 20 g/hari', needNote: 'anak 1–3 tahun (AKG 2019)'
    },
    {
      id: 'besi', name: 'Zat Besi (Fe)', formula: 'Fe<sup>2+</sup>',
      sub: 'ditampilkan sebagai kompleks besi terhidrasi',
      color: '#ff8a3d', mol: complexMol('Fe', 'O', OCTA, true),
      role: 'Komponen hemoglobin yang mengangkut oksigen ke seluruh jaringan, termasuk otak yang sedang tumbuh. Anemia defisiensi besi menurunkan nafsu makan, daya tahan tubuh, dan kemampuan belajar.',
      sources: ['Hati ayam', 'Daging merah', 'Ikan', 'Bayam', 'Kacang merah', 'Tempe'],
      need: '≈ 7 mg/hari', needNote: 'anak 1–3 tahun (AKG 2019)'
    },
    {
      id: 'zink', name: 'Zink (Zn)', formula: 'Zn<sup>2+</sup>',
      sub: 'ditampilkan sebagai kompleks zink tetrahedral',
      color: '#8b6cff', mol: complexMol('Zn', 'N', TETRA.map(function (p) { return [p[0] * 1.45, p[1] * 1.45, p[2] * 1.45]; }), true),
      role: 'Kofaktor lebih dari 300 enzim, termasuk yang mengatur pembelahan sel dan pemanjangan tulang. Suplementasi zink terbukti memperpendek durasi diare dan mendukung penambahan tinggi badan.',
      sources: ['Hati', 'Daging sapi', 'Telur', 'Kacang-kacangan', 'Udang', 'Tempe'],
      need: '≈ 3 mg/hari', needNote: 'anak 1–3 tahun (AKG 2019)'
    },
    {
      id: 'kalsium', name: 'Kalsium (Ca)', formula: 'Ca<sub>5</sub>(PO<sub>4</sub>)<sub>3</sub>OH',
      sub: 'ditampilkan sebagai fragmen hidroksiapatit tulang',
      color: '#2ee6c5', mol: CAP,
      role: 'Mineral utama penyusun kepadatan dan panjang tulang. Bersama vitamin D, kalsium menentukan seberapa jauh tulang panjang anak dapat bertumbuh selama masa balita.',
      sources: ['Susu', 'Keju', 'Yoghurt', 'Ikan teri', 'Tahu', 'Daun kelor', 'Brokoli'],
      need: '≈ 650 mg/hari', needNote: 'anak 1–3 tahun (AKG 2019)'
    },
    {
      id: 'vita', name: 'Vitamin A', formula: 'C<sub>20</sub>H<sub>30</sub>O',
      sub: 'ditampilkan sebagai retinol',
      color: '#ffb648', mol: RETINOL,
      role: 'Menjaga integritas lapisan usus agar penyerapan gizi optimal, memperkuat kekebalan terhadap infeksi, dan mendukung penglihatan. Kapsul vitamin A diberikan gratis di Posyandu setiap Februari dan Agustus.',
      sources: ['Hati', 'Telur', 'Wortel', 'Ubi jalar oranye', 'Bayam', 'Pepaya', 'Mangga'],
      need: '≈ 400 mcg RE/hari', needNote: 'anak 1–3 tahun (AKG 2019)'
    },
    {
      id: 'yodium', name: 'Yodium (I)', formula: 'C<sub>15</sub>H<sub>11</sub>I<sub>4</sub>NO<sub>4</sub>',
      sub: 'ditampilkan sebagai fragmen hormon tiroid beryodium',
      color: '#a855f7', mol: THYRO,
      role: 'Bahan baku hormon tiroid yang mengatur laju metabolisme dan pematangan otak. Kekurangan yodium pada masa janin menyebabkan gangguan perkembangan otak yang tidak dapat dipulihkan.',
      sources: ['Garam beryodium', 'Ikan laut', 'Rumput laut', 'Udang', 'Telur'],
      need: '≈ 90 mcg/hari', needNote: 'anak 1–3 tahun (AKG 2019)'
    }
  ];

  /* ─────────────────────────────────────────────────────
     4. PENYEBAB
     ───────────────────────────────────────────────────── */
  var CAUSES = [
    {
      icon: '<path d="M12 21s-7-4.5-7-10a7 7 0 0 1 14 0c0 5.5-7 10-7 10Z" stroke="currentColor" stroke-width="1.7"/><path d="M9 11h6M12 8v6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>',
      t: 'Gizi ibu sebelum & selama hamil',
      d: 'Ibu dengan Kurang Energi Kronis (KEK) atau anemia berisiko melahirkan bayi dengan berat lahir rendah — titik awal yang paling sering dari stunting.',
      s: 'Anemia pada ibu hamil masih di kisaran 1 dari 4 kehamilan'
    },
    {
      icon: '<path d="M6 4v9a6 6 0 0 0 12 0V4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><path d="M9 4v5M15 4v5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><path d="M12 19v3" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>',
      t: 'MPASI yang tidak adekuat',
      d: 'Setelah 6 bulan, ASI saja tidak lagi mencukupi. MPASI yang terlalu encer, minim protein hewani, atau diberikan terlalu dini/terlambat membuat anak defisit gizi kronis.',
      s: 'Hanya sebagian kecil balita memenuhi standar keragaman pangan minimum'
    },
    {
      icon: '<path d="M12 3c3 4 6 6.5 6 10a6 6 0 0 1-12 0c0-3.5 3-6 6-10Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>',
      t: 'Air bersih & sanitasi',
      d: 'Diare berulang dan infeksi usus (environmental enteropathy) merusak dinding usus sehingga makanan bergizi sekalipun tidak terserap dengan baik.',
      s: 'Sanitasi layak menurunkan risiko stunting secara signifikan'
    },
    {
      icon: '<circle cx="12" cy="8" r="3.2" stroke="currentColor" stroke-width="1.7"/><path d="M5 20c0-3.6 3.1-6 7-6s7 2.4 7 6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>',
      t: 'Pola asuh & pengetahuan',
      d: 'Praktik pemberian makan yang keliru, mitos seputar makanan anak, serta minimnya stimulasi psikososial memperbesar risiko gagal tumbuh.',
      s: 'Edukasi pengasuh adalah intervensi berbiaya rendah dan berdampak besar'
    },
    {
      icon: '<path d="M4 20V9l8-5 8 5v11" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M9 20v-6h6v6" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>',
      t: 'Kemiskinan & akses pangan',
      d: 'Keterbatasan ekonomi membatasi akses ke protein hewani, sayur, dan buah. Rumah tangga rawan pangan memiliki risiko stunting jauh lebih tinggi.',
      s: 'Kemiskinan adalah faktor risiko lintas-sektor yang paling kuat'
    },
    {
      icon: '<path d="M8 3v4M16 3v4M4 9h16" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><rect x="4" y="5" width="16" height="16" rx="2.5" stroke="currentColor" stroke-width="1.7"/><path d="M9 14h6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>',
      t: 'Layanan kesehatan tidak rutin',
      d: 'Imunisasi tidak lengkap, tidak rutin ke Posyandu, dan tidak mendapat suplementasi membuat masalah pertumbuhan terlambat terdeteksi.',
      s: 'Deteksi dini memungkinkan intervensi saat masih reversibel'
    }
  ];

  /* ─────────────────────────────────────────────────────
     5. TIMELINE 1000 HPK
     ───────────────────────────────────────────────────── */
  var TIMELINE = [
    {
      dot: 'Pra<br>hamil', phase: 'Sebelum kehamilan',
      t: 'Menyiapkan tubuh calon ibu',
      d: 'Remaja putri dan calon ibu perlu bebas anemia sebelum hamil. Cadangan zat besi yang cukup menentukan kualitas plasenta dan pertumbuhan janin sejak minggu pertama.',
      tags: ['Tablet tambah darah', 'Skrining anemia', 'Berat badan ideal']
    },
    {
      dot: '0–12<br>mgg', phase: 'Trimester 1',
      t: 'Pembentukan organ & tabung saraf',
      d: 'Asam folat sangat menentukan pada fase ini. Mual muntah berat yang tidak ditangani dapat menyebabkan defisit gizi awal kehamilan.',
      tags: ['Asam folat', 'ANC pertama', 'Yodium']
    },
    {
      dot: '13–27<br>mgg', phase: 'Trimester 2',
      t: 'Percepatan pertumbuhan janin',
      d: 'Kebutuhan energi dan protein ibu meningkat tajam. Pemantauan lingkar lengan atas (LILA) membantu mendeteksi KEK sejak dini.',
      tags: ['Protein tinggi', 'Ukur LILA', 'Kalsium']
    },
    {
      dot: '28–40<br>mgg', phase: 'Trimester 3',
      t: 'Penambahan berat & cadangan gizi janin',
      d: 'Sebagian besar cadangan zat besi bayi ditimbun pada trimester ini. Kelahiran prematur memutus proses tersebut dan meningkatkan risiko stunting.',
      tags: ['Zat besi', 'Cegah prematur', 'Persiapan menyusui']
    },
    {
      dot: '0–6<br>bln', phase: 'Bayi 0–6 bulan',
      t: 'ASI eksklusif',
      d: 'Inisiasi Menyusu Dini dalam 1 jam pertama, lalu ASI saja tanpa tambahan apa pun selama 6 bulan. ASI memberi antibodi yang tidak tergantikan formula.',
      tags: ['IMD', 'ASI eksklusif', 'Imunisasi dasar']
    },
    {
      dot: '6–12<br>bln', phase: 'Bayi 6–12 bulan',
      t: 'MPASI kaya protein hewani',
      d: 'Mulai MPASI tepat di usia 6 bulan dengan tekstur bertahap. Protein hewani harus hadir setiap hari — bukan hanya bubur dan sayur.',
      tags: ['Telur harian', 'Tekstur bertahap', 'Lanjut ASI']
    },
    {
      dot: '12–24<br>bln', phase: 'Anak 12–24 bulan',
      t: 'Jendela terakhir yang menentukan',
      d: 'Anak beralih ke makanan keluarga. Ini kesempatan terakhir memperbaiki tinggi badan secara signifikan sebelum pertumbuhan linier melambat.',
      tags: ['Makanan keluarga', 'Vitamin A', 'Pantau bulanan']
    }
  ];

  /* ─────────────────────────────────────────────────────
     6. DAFTAR PERIKSA PENCEGAHAN
     ───────────────────────────────────────────────────── */
  var CHECKLIST = [
    { t: 'Rutin periksa kehamilan minimal 6 kali', d: 'Termasuk 2 kali pemeriksaan oleh dokter dengan USG pada trimester 1 dan 3.', w: 'Masa hamil' },
    { t: 'Minum tablet tambah darah selama hamil', d: 'Minimal 90 tablet untuk mencegah anemia yang meningkatkan risiko BBLR.', w: 'Masa hamil' },
    { t: 'Inisiasi Menyusu Dini dalam 1 jam pertama', d: 'Kontak kulit ke kulit segera setelah lahir membantu keberhasilan menyusui.', w: 'Saat lahir' },
    { t: 'ASI eksklusif sampai 6 bulan', d: 'Tanpa air putih, madu, pisang, atau makanan tambahan lainnya.', w: '0–6 bulan' },
    { t: 'Mulai MPASI tepat di usia 6 bulan', d: 'Tidak terlalu dini dan tidak terlambat, dengan tekstur yang naik bertahap.', w: '6 bulan' },
    { t: 'Beri protein hewani setiap hari', d: 'Telur, ikan, hati ayam, atau daging — sumber zat besi dan zink terbaik.', w: '6–24 bulan' },
    { t: 'Lengkapi imunisasi dasar dan lanjutan', d: 'Mencegah infeksi berulang yang mengganggu penyerapan gizi.', w: '0–24 bulan' },
    { t: 'Timbang dan ukur anak setiap bulan', d: 'Bawa ke Posyandu agar tren pertumbuhan terpantau, bukan sekadar angka sesaat.', w: 'Rutin bulanan' },
    { t: 'Berikan kapsul vitamin A dua kali setahun', d: 'Gratis di Posyandu setiap Februari dan Agustus untuk anak 6–59 bulan.', w: 'Feb & Agu' },
    { t: 'Gunakan air bersih dan jamban sehat', d: 'Cuci tangan pakai sabun sebelum menyiapkan makanan dan setelah dari toilet.', w: 'Setiap hari' },
    { t: 'Obati diare dengan oralit dan zink', d: 'Zink selama 10–14 hari terbukti mempercepat pemulihan dan mencegah diare berulang.', w: 'Saat sakit' },
    { t: 'Beri stimulasi dan waktu bermain', d: 'Tumbuh kembang bukan hanya soal tinggi badan, tapi juga kemampuan otak dan sosial.', w: 'Setiap hari' }
  ];

  /* ─────────────────────────────────────────────────────
     7. KUIS
     ───────────────────────────────────────────────────── */
  var QUIZ = [
    {
      q: 'Anak disebut stunting bila tinggi badan menurut umurnya berada di bawah…',
      o: ['−1 SD dari median WHO', '−2 SD dari median WHO', '−3 SD dari median WHO', 'Rata-rata tinggi anak di kampungnya'],
      a: 1,
      e: 'Ambang batas stunting adalah di bawah −2 SD (standar deviasi) dari median Standar Pertumbuhan Anak WHO. Di bawah −3 SD dikategorikan sangat pendek (severely stunted).'
    },
    {
      q: 'Berapa lama periode "1000 Hari Pertama Kehidupan"?',
      o: ['Sejak lahir sampai usia 3 tahun', 'Sejak hamil sampai anak berusia 2 tahun', 'Sejak lahir sampai masuk SD', 'Dua tahun pertama pernikahan'],
      a: 1,
      e: '1000 HPK dihitung dari 270 hari masa kehamilan ditambah 730 hari (2 tahun) pertama kehidupan anak. Inilah periode emas yang tidak bisa diulang.'
    },
    {
      q: 'Manakah yang paling tepat untuk mencegah stunting pada anak usia 6–24 bulan?',
      o: ['Memperbanyak porsi bubur nasi', 'Memberi protein hewani setiap hari', 'Memberi susu formula sebanyak mungkin', 'Menunda MPASI sampai gigi tumbuh'],
      a: 1,
      e: 'Protein hewani (telur, ikan, hati, daging) adalah sumber zat besi dan zink yang paling mudah diserap tubuh. Bubur nasi saja tinggi karbohidrat tetapi miskin zat gizi mikro.'
    },
    {
      q: 'Apa hubungan sanitasi buruk dengan stunting?',
      o: ['Tidak ada hubungannya sama sekali', 'Hanya menyebabkan penyakit kulit', 'Infeksi berulang membuat gizi tidak terserap', 'Hanya berdampak pada orang dewasa'],
      a: 2,
      e: 'Diare berulang dan infeksi usus merusak dinding usus sehingga zat gizi gagal diserap. Karena itu perbaikan sanitasi disebut intervensi gizi sensitif.'
    },
    {
      q: 'Manakah pernyataan yang BENAR tentang genetik dan tinggi badan balita?',
      o: ['Anak pendek pasti karena keturunan', 'Genetik hanya sebagian kecil penentu pada balita', 'Genetik menentukan 90% tinggi balita', 'Etnis tertentu ditakdirkan pendek'],
      a: 1,
      e: 'Studi multi-negara WHO menunjukkan anak dari berbagai etnis tumbuh dengan pola yang sangat mirip bila gizi, kesehatan, dan sanitasinya memadai. Gizi jauh lebih menentukan daripada keturunan pada masa balita.'
    },
    {
      q: 'Kapan dampak stunting terhadap tinggi badan menjadi sangat sulit diperbaiki?',
      o: ['Setelah usia 6 bulan', 'Setelah usia 2 tahun', 'Setelah usia 10 tahun', 'Tidak pernah sulit diperbaiki'],
      a: 1,
      e: 'Setelah usia 2 tahun, pertumbuhan linier melambat dan kehilangan tinggi badan sebagian besar bersifat permanen. Intervensi setelahnya tetap berguna untuk kesehatan dan kognitif, tetapi tinggi badan sulit dikejar sepenuhnya.'
    },
    {
      q: 'Stunting terutama disebabkan oleh…',
      o: ['Kekurangan gizi akut dalam beberapa hari', 'Kekurangan gizi kronis dan infeksi berulang', 'Kurang olahraga', 'Terlalu banyak tidur'],
      a: 1,
      e: 'Stunting adalah indikator masalah gizi kronis — berlangsung berbulan-bulan hingga bertahun-tahun. Berbeda dengan wasting (kurus) yang mencerminkan kekurangan gizi akut.'
    },
    {
      q: 'Selain tinggi badan, dampak stunting yang paling dikhawatirkan adalah…',
      o: ['Warna kulit menjadi gelap', 'Perkembangan otak dan kemampuan belajar terganggu', 'Rambut menjadi keriting', 'Suara menjadi serak'],
      a: 1,
      e: 'Kekurangan gizi kronis pada masa emas menghambat pembentukan sinaps otak. Dampaknya terlihat pada prestasi sekolah dan potensi penghasilan saat dewasa — inilah alasan stunting disebut masalah kualitas sumber daya manusia.'
    }
  ];

  var QUIZ_RESULTS = [
    { min: 0, t: 'Masih banyak yang bisa dipelajari', d: 'Tidak apa-apa — informasi keliru soal stunting memang beredar luas. Coba baca kembali bagian 1000 HPK dan Gizi, lalu ulangi kuis ini.' },
    { min: 4, t: 'Pemahaman Anda cukup baik', d: 'Anda sudah menguasai dasar-dasarnya. Perdalam bagian penyebab dan pencegahan agar bisa menjelaskannya kepada orang lain di sekitar Anda.' },
    { min: 6, t: 'Pemahaman Anda kuat', d: 'Sebagian besar konsep penting sudah Anda kuasai. Anda siap membantu menyebarkan informasi yang benar tentang pencegahan stunting.' },
    { min: 8, t: 'Luar biasa — nilai sempurna!', d: 'Anda memahami stunting secara menyeluruh, dari definisi hingga intervensinya. Bagikan pengetahuan ini ke keluarga, tetangga, dan kader di lingkungan Anda.' }
  ];

  /* ─────────────────────────────────────────────────────
     8. FAQ
     ───────────────────────────────────────────────────── */
  var FAQ = [
    {
      q: 'Apa bedanya stunting, wasting, dan gizi buruk?',
      a: 'Stunting (pendek) diukur dari tinggi badan menurut umur dan mencerminkan kekurangan gizi kronis yang berlangsung lama. Wasting (kurus) diukur dari berat badan menurut tinggi badan dan mencerminkan kekurangan gizi akut yang baru terjadi. Gizi buruk adalah bentuk paling berat dari wasting. Seorang anak bisa mengalami keduanya sekaligus.'
    },
    {
      q: 'Apakah stunting bisa disembuhkan?',
      a: 'Bergantung pada usia. Di bawah 2 tahun, perbaikan gizi dan kesehatan masih dapat mengembalikan laju pertumbuhan secara bermakna. Di atas 2 tahun, tinggi badan yang hilang sulit dikejar sepenuhnya, tetapi intervensi tetap penting untuk memperbaiki kesehatan, imunitas, dan perkembangan kognitif anak. Karena itu fokus utama kebijakan adalah pencegahan, bukan pengobatan.'
    },
    {
      q: 'Anak saya pendek tapi aktif dan pintar. Apakah dia stunting?',
      a: 'Belum tentu. Sebagian anak memang berada di sisi bawah kurva tanpa mengalami masalah gizi. Yang perlu diperhatikan adalah tren pertumbuhan dari bulan ke bulan, bukan satu titik pengukuran saja. Bila garis pertumbuhan anak mendatar atau menurun melewati garis kurva, itu tanda peringatan yang harus segera diperiksa oleh tenaga kesehatan.'
    },
    {
      q: 'Apakah susu formula bisa mencegah stunting?',
      a: 'Susu formula bukan solusi utama. Untuk bayi di bawah 6 bulan, ASI eksklusif tetap yang terbaik. Setelah 6 bulan, yang paling menentukan adalah kualitas MPASI — terutama kehadiran protein hewani setiap hari. Susu dapat menjadi pelengkap, tetapi tidak bisa menggantikan makanan padat gizi, dan konsumsi susu berlebihan justru dapat menurunkan nafsu makan anak terhadap makanan lain.'
    },
    {
      q: 'Bagaimana cara mengukur tinggi badan anak yang benar di rumah?',
      a: 'Anak di bawah 24 bulan diukur dalam posisi berbaring (panjang badan) menggunakan infantometer, sedangkan anak 24 bulan ke atas diukur berdiri (tinggi badan) dengan stadiometer atau microtoise. Pastikan anak tidak memakai alas kaki maupun hiasan kepala, kepala menghadap lurus ke depan, dan tumit menempel pada dinding. Pengukuran di rumah bersifat perkiraan — hasil resmi sebaiknya diambil di Posyandu dengan alat terstandar.'
    },
    {
      q: 'Berapa biaya kalau anak saya terindikasi stunting?',
      a: 'Pemeriksaan dan pemantauan pertumbuhan di Posyandu tidak dipungut biaya. Kapsul vitamin A, imunisasi dasar, dan tablet tambah darah untuk ibu hamil juga disediakan gratis oleh pemerintah melalui Puskesmas. Bila diperlukan pemeriksaan lanjutan, layanan tersebut umumnya ditanggung JKN/BPJS Kesehatan. Jangan tunda pemeriksaan karena khawatir biaya.'
    },
    {
      q: 'Seberapa akurat kalkulator di situs ini?',
      a: 'Kalkulator ini menghitung skor-Z menggunakan interpolasi dari titik jangkar tabel Standar Pertumbuhan Anak WHO 2006, sehingga hasilnya adalah pendekatan — bisa berbeda sedikit dari tabel resmi lengkap. Alat ini dirancang untuk edukasi dan skrining awal, bukan diagnosis. Kesalahan pengukuran tinggi sebesar 1 cm saja sudah dapat menggeser skor-Z secara berarti, jadi selalu konfirmasi hasilnya ke tenaga kesehatan.'
    },
    {
      q: 'Saya bukan orang tua. Apa yang bisa saya lakukan?',
      a: 'Banyak. Anda bisa menjadi kader Posyandu di lingkungan Anda, membantu menyebarkan informasi yang benar untuk melawan mitos seputar makanan anak, mendukung program pemberian makanan tambahan di komunitas, atau memastikan keluarga dan tetangga yang memiliki balita rutin melakukan pemantauan pertumbuhan. Pencegahan stunting adalah kerja lintas-sektor, bukan hanya urusan orang tua.'
    }
  ];

  /* ───────────────────────────────────────────────────── */
  global.SITE_DATA = {
    WHO_HFA: WHO_HFA,
    whoRef: whoRef,
    heightAtZ: heightAtZ,
    zScore: zScore,
    zToPercentile: zToPercentile,
    classify: classify,
    adviceFor: adviceFor,
    PROVINCES: PROVINCES,
    NATIONAL: NATIONAL,
    TARGET: TARGET,
    provStatus: provStatus,
    EL: EL,
    NUTRIENTS: NUTRIENTS,
    CAUSES: CAUSES,
    TIMELINE: TIMELINE,
    CHECKLIST: CHECKLIST,
    QUIZ: QUIZ,
    QUIZ_RESULTS: QUIZ_RESULTS,
    FAQ: FAQ
  };
})(window);
